import * as React from "react";
import { VoucherState } from "../../../services/voucher";
import { VoucherWrap, LCircle, RCircle } from "./styles";
import styled from "styled-components";
import SmartImage from "../../../components/SmartImage";
const VoucherModuleWrapOne = styled.div `
	width: 100vw;
	position: relative;
	margin-bottom: 0.75rem;
`;
const ItemWrap = styled.section `
	width: 100%;
	min-height: 6.18rem;
	background-color: #fff;
	display: flex;
	justify-content: space-between;
`;
const ImgWrap = styled.div `
	display: flex;
	flex: 1;
	align-items: center;
	.img {
		width: 100%;
		height: 100%;
		display: block;
	}
`;
const Text = styled.div `
	width: 34%;
	text-align: center;
	font-size: 0.75rem;
	font-family: "SFProText-Heavy SFProText-Regular";
	font-weight: 800;
	position: relative;
	> a {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		margin: 0 0.75rem;
	}
`;
const LeftCircle = styled(LCircle) `
	top: 50%;
	transform: translateY(-50%);
`;
const RightCircle = styled(RCircle) `
	top: 50%;
	transform: translateY(-50%);
`;
const RedeemedStampImg = styled.img `
	position: absolute;
	right: 4.8125rem;
	height: 4.625rem;
	top: 50%;
	margin-top: -2.25rem;
`;
export default class VoucherOne extends React.Component {
    constructor() {
        super(...arguments);
        this.renderVoucherCard = (data, index) => {
            var _a;
            const { claimDown, callbackText, icons, baseColor, placeholderBg } = this.props;
            const { img = "", ui, voucherState, link, height } = data;
            const isFinishOrFullyReceem = voucherState === VoucherState.ComingSoon || voucherState === VoucherState.Expired;
            const styles = { backgroundColor: baseColor || "#f7f7f7", display: "flex" };
            return (React.createElement(VoucherWrap, { style: styles, key: index },
                React.createElement(VoucherModuleWrapOne, null,
                    React.createElement(ItemWrap, null,
                        React.createElement(ImgWrap, null,
                            React.createElement(SmartImage, { src: img, qnParams: { w: 750 }, placeholder: placeholderBg, fallbackSrc: placeholderBg, imgClass: "img", style: isFinishOrFullyReceem
                                    ? { filter: "grayscale(100%)", opacity: 0.4, height }
                                    : { height } })),
                        React.createElement(Text, { style: isFinishOrFullyReceem
                                ? { backgroundColor: "#ddd", color: "#6E6E6E" }
                                : { backgroundColor: ui === null || ui === void 0 ? void 0 : ui.bgColor, color: (_a = ui === null || ui === void 0 ? void 0 : ui.colorTable) === null || _a === void 0 ? void 0 : _a.textColor }, onClick: () => claimDown(data) },
                            React.createElement("a", null, callbackText(voucherState, !!link))),
                        voucherState !== VoucherState.RanOut && (React.createElement(RedeemedStampImg, { src: icons, onClick: () => claimDown(data) }))),
                    React.createElement(LeftCircle, { style: styles }),
                    React.createElement(RightCircle, { style: styles }))));
        };
    }
    render() {
        const { vouchers, positionId } = this.props;
        return (React.createElement("section", { id: positionId, "data-name": "vouchrone" }, vouchers.map((item, index) => this.renderVoucherCard(item, index))));
    }
}
